<template>
  <HeaderBase>
    <div
      class="flex items-center header-title cursor-pointer"
      @click="$router.push({
        name: 'objects',
      })">
      <span class="arrow arrow-l arrow-primary"></span>
      <span>
        <b>Объект: </b>
        <b class="text-muted">{{ $delve(object, 'id') }}</b>
      </span>
    </div>
    <div class="flex flex-row space-x-6">
      <div class="flex flex-row items-center space-x-1">
        <span class="text-14px leading-16px text-muted">Создан:</span>
        <b class="text-14px leading-16px">
          {{ moment($delve(object, 'createdAt')).format('DD.MM.YYYY') }}
        </b>
      </div>
    </div>
  </HeaderBase>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import HeaderBase from './HeaderBase.vue';

export default {
  components: {
    HeaderBase,
  },
  computed: {
    ...mapGetters({
      objectsGetter: 'objects/object',
    }),
    id() {
      return _.get(this.$route, 'params.id');
    },
    object() {
      if (this.id) {
        return this.objectsGetter(this.id);
      }
      return null;
    },
  },
  methods: {
    moment(data, format) {
      return moment(data, format);
    },
  },
};
</script>
